import { defineStore } from 'pinia'

export const useLocationStore = defineStore('locationStore', () => {
  const { API_ENDPOINTS } = useApiEndpoints()
  
  const cities = ref([])
  const districts = ref([])
  const loading = ref({
    cities: false,
    districts: false
  })

  // İlleri getir
  const fetchCities = async () => {
    loading.value.cities = true
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.public.locations.cities(1)
      )
      cities.value = response
      return response
    } catch(error) {
      console.error('İlleri getirme hatası:', error)
      return []
    } finally {
      loading.value.cities = false
    }
  }

  // İlçeleri getir
  const fetchDistricts = async (cityId) => {
    if (!cityId) {
      districts.value = []
      return []
    }
    
    loading.value.districts = true
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.public.locations.districts(cityId)
      )
      districts.value = response
      return response
    } catch(error) {
      console.error('İlçeleri getirme hatası:', error)
      return []
    } finally {
      loading.value.districts = false
    }
  }

  return {
    cities,
    districts,
    loading,
    fetchCities,
    fetchDistricts
  }
}) 